import * as React from "react"
import { Box } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"


export default function ArrowBackground({ value, prev, backgroundColor, sx={}, children }) {
	const isPositive = prev < value

	return <Box component="span" sx={{ p: 1, borderRadius: 1.2, backgroundColor: backgroundColor, ...sx }}>
		{children}
		{ !!prev && <IconSeeker
			sx={{ ml: .5 }}
			icon={isPositive ? 'arrow-up' : 'arrow-down'}
			color={isPositive ? 'success.main' : 'error.main'}
		/> }
	</Box>
}